// Human-readable names for the backend's auction_type / auction_mode values.
// The wording mirrors the New Auction form so a type reads the same
// everywhere it is shown.

const TYPE_LABELS: Record<string, string> = {
  english_no_tie: "English Auction (No Tie)",
  english: "English Auction",
  traffic_light: "Traffic Light English Auction",
};

const MODE_LABELS: Record<string, string> = {
  reverse: "Reverse Auction",
  forward: "Forward Auction",
};

// Falls back to a title-cased version of an unknown value rather than
// showing a raw snake_case string.
const prettify = (value: string) =>
  value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export function auctionTypeLabel(type?: string | null): string {
  if (!type) return "English Auction (No Tie)"; // backend default
  return TYPE_LABELS[type] ?? prettify(type);
}

export function auctionModeLabel(mode?: string | null): string {
  return MODE_LABELS[mode === "forward" ? "forward" : "reverse"];
}
